import pckg from '../../package.json';
import { isProductionEnv } from '@demo-system/commons/service/environment';

const TEST_LAUNCH_URL =
  '//assets.adobedtm.com/ef7912a2f29c/5551523ff6e7/launch-79ab12bdc3c8-development.min.js';
const PRODUCTION_LAUNCH_URL =
  '//assets.adobedtm.com/ef7912a2f29c/5551523ff6e7/launch-4fcacb4d0f37.min.js';

const launchUrl = isProductionEnv() ? PRODUCTION_LAUNCH_URL : TEST_LAUNCH_URL;

const sendEvent = (interactionName) => () => {
  window.dataLayer.toolInteraction = interactionName;
  document.body.dispatchEvent(new CustomEvent('toolInteraction'));
};

const getter = (propName) => () => {
  if (!window.dataLayer) {
    console.error('Data Layer object not initialized.');
  }
  return window.dataLayer && window.dataLayer[propName];
};

const setter = (propName) => (value) => {
  if (!window.dataLayer) {
    console.error('Data Layer object not initialized.');
  }
  window.dataLayer[propName] = value;
};

const init = () => {
  window.dataLayer = {
    toolName: 'Dashboard',
    toolVersion: pckg.version,
    projectTitle: '',
    projectTemplate: '',
    userID: '',
    toolInteraction: '',
    projectID: '',
    workspaceName: '',
    workspaceID: '',
    jobName: ''
  };

  const script = document.createElement('script');
  script.src = launchUrl;
  script.async = true;
  document.body.appendChild(script);
};

const sendJobEvent =
  (interactionName, toolName) =>
  (suffix = '', jobName) => {
    window.dataLayer = {
      ...(window.dataLayer || {}),
      toolName: toolName || '',
      workspaceName: '',
      workspaceID: '',
      jobName: jobName || ''
    };
    sendEvent(interactionName + suffix?.replaceAll(/[&<>]/gm, ''))();
  };

const getUser = getter('userID');

const setUser = setter('userID');

const setWizardName = setter('wizardName');
const setConfigurationName = setter('configurationName');
const setConfigurationStatus = setter('configurationStatus');

const clearConfiguration = () => {
  setConfigurationName('');
  setConfigurationStatus('');
};

//
// Actions
//

const triggerToolStart = sendEvent('Dashboard:Launch');
const triggerQuickSetupStart = sendJobEvent('Quick Setup:Start', 'Quick Setup');
const triggerQuickSetupJob = sendJobEvent('Quick Setup:Job:', 'Quick Setup');

// Legacy triggers
const triggerWizardStart = sendEvent('Dashboard:Wizard:Start');
const triggerConfigurationStart = sendEvent('Dashboard:Configuration Start');
const triggerConfigurationEnd = sendEvent('Dashboard:Configuration End');

export default {
  init,

  getUser,
  setUser,
  triggerToolStart,
  triggerQuickSetupStart,
  triggerQuickSetupJob,

  setWizardName,
  setConfigurationName,
  setConfigurationStatus,
  clearConfiguration,

  triggerWizardStart,
  triggerConfigurationStart,
  triggerConfigurationEnd
};
